import { DateTime } from 'luxon';
import React from 'react';
import { Card, Cover, SmallBodyText } from '../../../../ui-toolkit';
import ProgressBar from '../ProgressBar/ProgressBar';
import styled from 'styled-components';
import generateProgressBarProps from './generateProgressBarProps';
import { eExternalOrderStatus } from '../../../../ui-toolkit/enums/eExternalOrderStatus';
import { eInternalOrderStatus } from '../../../../ui-toolkit/enums/eInternalOrderStatus';
import { IOrderDetailsData } from '../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

const Grid = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.baseValue * 9}px;
  grid-template:
    'title timestamp'
    'bar bar ' / 1fr max-content;
  position: relative;
`;

const StyledCover = styled(Cover)`
  top: 50px;
`;

const Timestamp = styled(SmallBodyText)`
  color: ${(props) => props.theme.colors.gray};
  grid-area: timestamp;
  text-align: right;
`;

const StyledProgressBar = styled.div`
  grid-area: bar;
`;

interface IOrderProgressProps {
  order: IOrderDetailsData;
  closingDate?: string;
}

const OrderProgress: React.FC<IOrderProgressProps> = ({ order, closingDate }) => {
  const { created, externalStatus, updated, status } = order.orderInformation;
  const createdDateTime = DateTime.fromISO(created);
  const { items, position } = generateProgressBarProps({
    status: status ?? eInternalOrderStatus.new,
    externalStatus: externalStatus ?? eExternalOrderStatus.new,
    created: createdDateTime.toJSDate(),
    signed: closingDate ? DateTime.fromISO(closingDate).toJSDate() : undefined,
    done: updated && status === eInternalOrderStatus.complete ? DateTime.fromISO(updated).toJSDate() : undefined, // TODO: get done date when it gets added to order schema
  });
  return (
    <Card>
      <Grid>
        <Timestamp>{updated ? DateTime.fromISO(updated).toFormat(`'Updated' DDD 'at' t ZZZZ`) : <>&nbsp;</>}</Timestamp>
        <StyledProgressBar>
          <ProgressBar items={items} position={position} />
        </StyledProgressBar>
      </Grid>
      {status === eInternalOrderStatus.cancelled ? <StyledCover clickThrough={true} /> : null}
    </Card>
  );
};

export default OrderProgress;
